module.exports = __webpack_public_path__ + "media/bootstrap-icons/plug-fill-7817d89d.svg";